import {
  AccountInfo,
  AuthenticationResult,
  InteractionRequiredAuthError,
  IPublicClientApplication
} from '@azure/msal-browser';
import { loginRequest } from 'environment/SsoConfig';

const noTokenPromise = Promise.resolve({
  accessToken: 'no-token'
} as AuthenticationResult);

export const getMsalToken = (loggedAccount: AccountInfo, instance: IPublicClientApplication) =>
  instance
    .acquireTokenSilent({
      ...loginRequest,
      account: loggedAccount
    })
    .catch(async (error: unknown): Promise<AuthenticationResult> => {
      console.error(error);

      if (error instanceof InteractionRequiredAuthError) {
        // Redirects the user to the Microsoft login page, which normally navigates away before this resolves.
        await instance.acquireTokenRedirect(loginRequest);
      }

      return noTokenPromise;
    });
